import React from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpRemoveFromCart } from '../../../Hooks/user/user.post.hooks';
import Auth from '../../../Helpers/auth';
import { removeFromGuestCart } from '../../../Routes/MainComponents/navigation/GuestCart';
import { DeleteCartItemWrapper, DeleteCartButton } from '../Course.styles';

const DeleteCartItem = ({
  courseId,
  userId,
  productId,
  itemType = 'course',
}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ courseId, userId, productId, itemType }) =>
      httpRemoveFromCart({ courseId, userId, productId, itemType }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          Array.isArray(query.queryKey) && query.queryKey[0] === 'cart',
      });
    },
    onError: (error) => {
      console.error('Error removing cart item:', error);
    },
  });

  const deleteCourseFromCart = () => {
    const resolvedUserId =
      userId || Auth.getProfile()?.data?.id || localStorage.getItem('temp_id');

    const resolvedCourseId =
      courseId && typeof courseId === 'object'
        ? courseId._id || courseId.courseId || courseId.id
        : courseId;

    // If there's no auth token, treat this as a guest cart and remove locally
    if (!Auth.getToken()) {
      try {
        removeFromGuestCart(resolvedCourseId);
        queryClient.invalidateQueries({
          predicate: (query) =>
            Array.isArray(query.queryKey) && query.queryKey[0] === 'cart',
        });
      } catch (err) {
        console.error('Error removing guest cart item:', err);
      }
      return;
    }

    mutation.mutate({
      courseId: resolvedCourseId,
      userId: resolvedUserId,
      productId,
      itemType,
    });
  };

  return (
    <DeleteCartItemWrapper>
      <DeleteCartButton
        onClick={deleteCourseFromCart}
        title="Remove from cart"
        aria-label="Remove from cart"
      >
        ×
      </DeleteCartButton>
    </DeleteCartItemWrapper>
  );
};

DeleteCartItem.propTypes = {
  courseId: PropTypes.string,
  userId: PropTypes.string,
  productId: PropTypes.string,
  itemType: PropTypes.string,
};

export default DeleteCartItem;
